import { Tabs } from "@shared/ui/tabs";
import { useNavigate, useParams } from "react-router-dom";
import PerformanceTab from "./tabs/performanceTab/performanceTab";
import RunHistoryTab from "./tabs/runHistoryTab/runHistoryTab";

const urlMapping = {
  performance: "performance",
  runHistory: "run-history",
};

export default function ReadCycleRunsTab() {
  const navigate = useNavigate();
  const { cycle_id } = useParams();

  const tabComponents = {
    performance: {
      label: "Performance",
      shortLabel: "Performance",
      component: <PerformanceTab />,
    },
    runHistory: {
      label: "Run History",
      shortLabel: "Run History",
      component: <RunHistoryTab />,
    },
  };

  return (
    <div>
      <Tabs
        defaultValue="performance"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        idPrefix="readCycle-tab"
        level={1}
      />
    </div>
  );
}
